import styled from "@emotion/styled";
import React from "react";
import { AppAbstractModal } from "./Generic/AppModal/AppAbstractModal";
import ModalHeadline from "./Generic/AppModal/components/ModalHeadline/ModalHeadline";
import { AppOverlay } from "./Generic/AppOverlay";

interface Props {
  animation: React.ReactNode;
  animationOffset?: number;
  headline: React.ReactNode;
  message: React.ReactNode;
  actions: React.ReactNode;
  className?: string;
  isOpen: boolean;
  children?: React.ReactChildren;
  onRequestClose: () => void;
}

const AnimatedModal = (props: Props) => {
  return (
    <AppOverlay>
      <AnimatedModal.Styled
        className={props.className}
        isOpen={props.isOpen}
        onRequestClose={props.onRequestClose}
      >
        <AnimatedModal.AnimationWrapper offset={props.animationOffset ?? 0}>
          {props.animation}
        </AnimatedModal.AnimationWrapper>
        <AnimatedModal.Headline>{props.headline}</AnimatedModal.Headline>
        <AnimatedModal.Message>{props.message}</AnimatedModal.Message>
        {props.children}
        <AnimatedModal.Actions>{props.actions}</AnimatedModal.Actions>
      </AnimatedModal.Styled>
    </AppOverlay>
  );
};

AnimatedModal.AnimationWrapper = styled.div<{ offset: number }>`
  margin-top: ${(props) => props.offset * -1}px;
  width: 100%;
`;

AnimatedModal.Headline = styled(ModalHeadline)`
  text-align: center;
`;

AnimatedModal.Message = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  > p {
    text-align: center;
    margin: 0;
  }
`;

AnimatedModal.Actions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;

  > *:last-child:not(:first-of-type) {
    margin-bottom: -24px;
  }
`;

AnimatedModal.Styled = styled(AppAbstractModal)`
  > .container {
    background-color: #fff;
    border-radius: 24px;
    box-sizing: border-box;
    padding: 32px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    text-align: center;
    max-height: 90vh;
  }

  ${AnimatedModal.Message} + ${AnimatedModal.Actions} {
    margin-top: 32px;
  }
`;

export default AnimatedModal;
